import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef } from 'react';
import { ThemeProvider } from 'styled-components';
import { S as Surface } from './Surface-f4eeb87d.js';
import { s as surfaceModifier } from '../theme/colorModifiers/surface-a750c446.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-f5c69fbd.js';

function createSurface(surfaceType) {
  return /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: theme => surfaceModifier(theme, surfaceType)
  }, /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: props.taktId,
    taktValue: props.taktValue
  }, /*#__PURE__*/React__default.createElement(Surface, _extends({}, props, {
    ref: ref
  })))));
}

export { createSurface as c };
//# sourceMappingURL=createSurface-e2c22227.js.map
